import groupBy from 'lodash/groupBy';
import { useTranslation } from '@common/Hooks/useTranslation';
import { ActiveFiltersGroup } from './ActiveFiltersGroup';

export function ActiveFiltersList({
    filters,
    isGroupByType,
    onClick
}) {
    const translate = useTranslation();

    if (isGroupByType) {
        const groupedFilters = groupBy(filters, 'filterType');

        return Object.keys(groupedFilters).map((group) => {
            const groupLabel = translate(`listing.filter.${group.replace('tag-', '')}.label`);
            return (
                <ActiveFiltersGroup
                    filters={groupedFilters[group]}
                    groupLabel={groupLabel}
                    onFilterClick={onClick}
                />
            );
        });
    }

    return (
        <ActiveFiltersGroup
            filters={filters}
            onFilterClick={onClick}
        />
    );
}
